import { createApp } from "vue";
import App from "../App.vue";
import router from "@/router";

import { createPinia } from "pinia";
import { ApolloClient, InMemoryCache } from "@apollo/client/core";
import { useDataStore } from "@/stores/data";
import { HttpLink } from "@apollo/client/core";
import { onError } from "@apollo/client/link/error";
import { useToast } from "vue-toastification";

const pinia = createPinia();
const app = createApp(App);
app.use(pinia);

const toast = useToast();

export const AUTH_CONTEXT = () => {
  const token = localStorage.getItem("token");
  return token ? `Bearer ${token}` : "";
};
const removeFromLocalStorage = () => {
  localStorage.removeItem("token");
  localStorage.removeItem("refreshToken");
  localStorage.removeItem("companyDetails");
  localStorage.removeItem("role");
  localStorage.removeItem("companyId");
  localStorage.removeItem("accountType");
};
export const logout = () => {
  const store = useDataStore();

  removeFromLocalStorage();

  store.$patch({
    isLoggedIn: false,
  });

  store.$reset();

  router.push("/");
};
let errorShown = false;

const errorLink = onError((errors) => {
  const { graphQLErrors, networkError } = errors;
  console.log(errors);

  if (graphQLErrors && graphQLErrors.length > 0) {
    let e = graphQLErrors[0];
    //check for bad user input

    if (e.message.includes("Bad user input")) {
      toast.error("Please check your input");
    } else if (
      e.extensions.code != "INVALID_TOKEN" &&
      !e.message.toLowerCase().includes("token")
    ) {
      toast.error(e.message);
    }

    for (let err of graphQLErrors) {
      switch (err.extensions.code) {
        case "INVALID_TOKEN":
          logout();
          break;
      }
    }
  }

  if (networkError) {
    toast.error(networkError.message);
  }
});

function getService(link) {
  const API = new ApolloClient({
    link,
    cache: new InMemoryCache(),
    defaultOptions: {
      watchQuery: {
        fetchPolicy: "no-cache",
        errorPolicy: "ignore",
      },
      query: {
        fetchPolicy: "no-cache",
        errorPolicy: "all",
      },
    },
  });

  return API;
}

// Which backend this build talks to is decided by --mode (`npm run dev` /
// `build:development` resolve via .env.development, `npm run build` / `prod`
// resolve via .env.production). To point a local dev server at a different backend
//  one-off, put VITE_BURSE_API_URL in a gitignored .env.development.local instead of editing this file.
if (!import.meta.env.VITE_BURSE_API_URL) {
  throw new Error(
    "VITE_BURSE_API_URL is not set — check .env.production/.env.development for the current --mode.",
  );
}
const httpLink_burse = new HttpLink({
  uri: import.meta.env.VITE_BURSE_API_URL,
});
const burseHttpLink = errorLink.concat(httpLink_burse);

const BURSE_API = getService(burseHttpLink);

export const API = {
  BURSE_API,
};
